/* eslint-disable */
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

// components
import { Grid, Button, Typography } from '@mui/material'
import AddGroupsModal from './components/addGroupsModal'
import InputLabel from '../inputLabel'
import GroupsTextField from './components/groupsTextField'
import AddIcon from '@mui/icons-material/Add'
const LABEL_STYLES = { paddingTop: '10px' }

const GroupsField = ({
  user,
  setUser,
  getSelectedGroupsCount,
  groupsModalInfo,
  isCreateUser = false,
}) => {
  const [showModal, setShowModal] = useState(false)
  const { t } = useTranslation()

  const handleSelectGroup = () => {
    setShowModal(true)
  }
  return (
    <>
      <Grid
        container
        style={{
          flexDirection: 'column',
          gap: '8px',
          display: 'flex',
          width: '150px',
          marginTop: '10px',
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          style={{
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '140%',
            fontFamily: 'Johnson Text',
          }}
        >
          {t('groups-field-label')}
        </Typography>
        <Typography
          variant="body1"
          gutterBottom
          style={{
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: '140%',
            maxWidth: '400px',
            width: '100vw',
            fontFamily: 'Johnson Text',
          }}
        >
          {t('groups-field-sub-heading')}
        </Typography>
        <Button
          onClick={handleSelectGroup}
          type="submit"
          disabled={isCreateUser && user.groups?.length == 5}
          sx={{
            fontFamily: 'Johnson Text',
            maxWidth: '150px',
            backgroundColor: 'black',
            color: 'white',
            borderRadius: '999px',
            '&:hover': {
              backgroundColor: 'black',
              boxShadow: 'none',
            },
            '&.Mui-disabled': {
              backgroundColor: 'rgba(0, 0, 0, 0.12)',
              color: 'rgba(0, 0, 0, 0.35)',
            },
          }}
        >
          <AddIcon /> {t('groups-field-add-icon')}
        </Button>
        {user.groups?.length > 0 && (
          <InputLabel
            label={
              <div>
                {t('groups-field-selected-groups')}{' '}
                <span style={{ color: '#eb1700', fontSize: '16px' }} />
              </div>
            }
            styles={LABEL_STYLES}
          />
        )}
      </Grid>
      {user.groups?.length > 0 && (
        <GroupsTextField user={user} setUser={setUser} />
      )}
      {showModal && (
        <AddGroupsModal
          showModal={showModal}
          setShowModal={setShowModal}
          user={user}
          setUser={setUser}
          getSelectedGroupsCount={getSelectedGroupsCount}
        />
      )}
    </>
  )
}

export default GroupsField
